// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fBNftwaa8zRqx0y8n9MC {
  font-size: 8px;
}

.LL9XZ5E8Zrt3jeWx7qtl {
  width: 8px;
  height: 8px;
}

.NbLpxx9cCzeoc79M9OV2 {
  font-size: 12px;
}

.i1MQIqPeVBZyEhXDmSFJ {
  width: 12px;
  height: 12px;
}

.S2fCdnF2KEjmv7socPbR {
  font-size: 14px;
}

.T0HKQdq9tHn27OTz_JQA {
  width: 14px;
  height: 14px;
}

.OHDg8DEfPSBgJHRWsSPZ {
  font-size: 16px;
}

.rQDAyCcSGjvUpSCqbdWX {
  width: 16px;
  height: 16px;
}

.zaL4XJntIONGRG1FLIeh {
  font-size: 18px;
}

.PbjTEayMxtIK2FElY3ZQ {
  width: 18px;
  height: 18px;
}

.bVVjKeJuXU2gdXIZBSdS {
  font-size: 24px;
}

.H_RceSvAuNP2h1YHlJkX {
  width: 24px;
  height: 24px;
}

.g_3Bd50kwXfQ99w_K0Vi {
  font-size: 32px;
}

.AL45xdVgvqw8y4Zcsi2o {
  width: 32px;
  height: 32px;
}

.o5fLM2198Xnb2bOQ6sf_ {
  font-size: 36px;
}

.HuJ5R8lrHCzjo4zdMO1Y {
  width: 36px;
  height: 36px;
}

.oyJQN7g3gn9tiBDWmord {
  font-size: 40px;
}

.mOFTaNgYojQqNGAXeg2r {
  width: 40px;
  height: 40px;
}`, "",{"version":3,"sources":["webpack://./tcbase/static/js2/components/icon.module.scss"],"names":[],"mappings":"AAIE;EACE,cAAA;AAHJ;;AAME;EACE,UAAA;EACA,WAAA;AAHJ;;AAHE;EACE,eAAA;AAMJ;;AAHE;EACE,WAAA;EACA,YAAA;AAMJ;;AAZE;EACE,eAAA;AAeJ;;AAZE;EACE,WAAA;EACA,YAAA;AAeJ;;AArBE;EACE,eAAA;AAwBJ;;AArBE;EACE,WAAA;EACA,YAAA;AAwBJ;;AA9BE;EACE,eAAA;AAiCJ;;AA9BE;EACE,WAAA;EACA,YAAA;AAiCJ;;AAvCE;EACE,eAAA;AA0CJ;;AAvCE;EACE,WAAA;EACA,YAAA;AA0CJ;;AAhDE;EACE,eAAA;AAmDJ;;AAhDE;EACE,WAAA;EACA,YAAA;AAmDJ;;AAzDE;EACE,eAAA;AA4DJ;;AAzDE;EACE,WAAA;EACA,YAAA;AA4DJ;;AAlEE;EACE,eAAA;AAqEJ;;AAlEE;EACE,WAAA;EACA,YAAA;AAqEJ","sourcesContent":["@import \"/tcbase/static/style/settings/settings.rl.variables.scss\"; @import \"/tcbase/static/style/settings/settings.bs.variables.scss\";\n$icon-sizes: 8, 12, 14, 16, 18, 24, 32, 36, 40;\n\n@each $size in $icon-sizes {\n  .icon-size-#{$size} {\n    font-size: #{$size}px;\n  }\n\n  .icon-dimension-#{$size} {\n    width: #{$size}px;\n    height: #{$size}px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon-size-8": `fBNftwaa8zRqx0y8n9MC`,
	"icon-dimension-8": `LL9XZ5E8Zrt3jeWx7qtl`,
	"icon-size-12": `NbLpxx9cCzeoc79M9OV2`,
	"icon-dimension-12": `i1MQIqPeVBZyEhXDmSFJ`,
	"icon-size-14": `S2fCdnF2KEjmv7socPbR`,
	"icon-dimension-14": `T0HKQdq9tHn27OTz_JQA`,
	"icon-size-16": `OHDg8DEfPSBgJHRWsSPZ`,
	"icon-dimension-16": `rQDAyCcSGjvUpSCqbdWX`,
	"icon-size-18": `zaL4XJntIONGRG1FLIeh`,
	"icon-dimension-18": `PbjTEayMxtIK2FElY3ZQ`,
	"icon-size-24": `bVVjKeJuXU2gdXIZBSdS`,
	"icon-dimension-24": `H_RceSvAuNP2h1YHlJkX`,
	"icon-size-32": `g_3Bd50kwXfQ99w_K0Vi`,
	"icon-dimension-32": `AL45xdVgvqw8y4Zcsi2o`,
	"icon-size-36": `o5fLM2198Xnb2bOQ6sf_`,
	"icon-dimension-36": `HuJ5R8lrHCzjo4zdMO1Y`,
	"icon-size-40": `oyJQN7g3gn9tiBDWmord`,
	"icon-dimension-40": `mOFTaNgYojQqNGAXeg2r`
};
export default ___CSS_LOADER_EXPORT___;
